import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, tap} from 'rxjs';
import {DISPATCHER_PREFIX} from '../../../../../../../mx-core/src/lib/consts/data-service-consts';

const PORTAL_TERMS_AND_CONDITIONS_REST: string = DISPATCHER_PREFIX + '/terms-and-conditions';

@Injectable({
    providedIn: 'root'
})
export class PrlTermsAndConditionsPageService {

    constructor(
        private httpClient: HttpClient
    ) {
    }

    public setIsTcAccepted(): Observable<Boolean> {
        return this.httpClient.get<Boolean>(`${PORTAL_TERMS_AND_CONDITIONS_REST}/is-last-accepted`).pipe(
            tap(resp => {
                localStorage.setItem('isTcAccepted', resp.toString());
            })
        );
    }

    public acceptLastVersion(): Observable<Boolean> {
        return this.httpClient.post<Boolean>(`${PORTAL_TERMS_AND_CONDITIONS_REST}/accept-last-version`, {});
    }

    public getContent(): Observable<string> {
        return this.httpClient.get(`${PORTAL_TERMS_AND_CONDITIONS_REST}/last-version-content`, {responseType: 'text'});
    }
}
